export default "__VITE_ASSET__TEK4n0E___"